import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { environment } from '../../environments/environment';

import { Article } from './article';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/of';

@Injectable()
export class ArticleService {

  public cache:Article[] = [];

  constructor(private http:Http) {
  }

  public getAllArticles():Observable<Article []> {

    if (this.cache.length != 0) {
      return Observable.of(this.cache);
    }

    //noinspection TypeScriptUnresolvedFunction
    return this.http.get(environment.urls.getArticles)
      .map(res => res.json() || {})
      .do(articles => {
        articles.map(article => {
          article.waterproof = article.waterproof == '1' ? true : false;
          article.book_release = article.book_release == '1' ? true : false;
        });
        this.cache = articles
      })
      .catch(err => Observable.throw(err.toString()));
  }

  public getArticleDetails(isbn):Observable<any> {
    /*
     * returns an observable
     * either fetches the article from the cache if available
     * or first start request to bookshelf (API) and return the details afterwards
     **/
    return new Observable(observer => {
      if (this.cache.length != 0) {
        observer.next(this.findArticleByIsbn(isbn));
      } else {
        this.getAllArticles().subscribe(articles => {
          observer.next(this.findArticleByIsbn(isbn));
        });
      }
    });
  }

  private findArticleByIsbn(isbn):Article {
    return this.cache.filter(article => {
      return article.isbn == isbn;
    }).pop();
  }

  public updateArticle(article):Observable<any> {
    // clear cache
    this.cache = [];

    // request to bookshelf
    let headers = new Headers({'Content-Type': 'application/json'});
    let options = new RequestOptions({headers: headers, withCredentials: true});

    return this.http.put(environment.urls.updateArticle, JSON.stringify(article), options);
  }

  public updateArticleImage(formData):Observable<any> {
    // clear cache
    this.cache = [];

    let options = new RequestOptions({withCredentials: true});

    return this.http.post(environment.urls.updateArticleImage, formData, options);
  }

  public createArticle(formData):Observable<any> {
    this.cache = [];

    // request to bookshelf
    let options = new RequestOptions({withCredentials: true});

    return this.http.post(environment.urls.createArticle, formData, options);
  }

  public deleteArticle(isbn):Observable<any> {
    this.cache = [];

    // request to bookshelf
    let options = new RequestOptions({withCredentials: true});

    return this.http.delete(environment.urls.deleteArticle + '/' + isbn, options);
  }
}





// WEBPACK FOOTER //
// ./src/app/article/article.service.ts